import { DATE_MONTH_YEAR_VIEW_FORMAT } from '../constants/Constants';
import {
  convertTravelTime,
  formatDate,
  formatTimeString,
  getCabinBaggage,
  getConnectingTime,
  getNewDate,
} from './appUtils';

export const getPassengerCount = (searchRequest) =>
  ['numadults', 'numchildren', 'numinfants'].reduce(
    (total, key) => total + (parseInt(searchRequest?.[key], 10) || 0),
    0,
  );

export const getStopsText = (numberOfStops) => {
  const stops = Number(numberOfStops) || 0;
  return stops === 0 ? 'Non Stop' : `${stops} Stop${stops > 1 ? 's' : ''}`;
};

export const getFlightShareHeader = () =>
  'Hello, please find details with regards to your flight query for:\n\n';

export const getFlightShareFooter = ({ companyName, contactNumber, email }) =>
  `\nThank you for choosing ${companyName || 'Fastays'}\n` +
  'In case of any urgent support :\n' +
  `Contact : ${contactNumber || ''}\n` +
  `Email : ${email || ''}\n` +
  'As powered by Fastays';

export const formatFlightJourneyForWhatsApp = ({
  flight,
  fare,
  cabinType,
  currency,
  fareAmount,
  passengerCount,
  showFare,
  baggageWeights = fare?.flightBagWeight || [],
  baggageUnits = fare?.flightBagUnit || [],
}) => {
  let message = '';
  const legs = flight?.flightlegs || [];

  legs.forEach((leg, index) => {
    message += `*Flight Name* ${
      leg.validatingcarriername
    } ${leg.carrier.substring(0, 2)} - ${leg.flightnumber}\n`;
    message += `*Flight Location* ${leg.origin_name} - ${formatDate(
      getNewDate(leg.depdate),
      DATE_MONTH_YEAR_VIEW_FORMAT,
    )} ${formatTimeString(leg.deptime)} --> ${
      leg.destination_name
    } - ${formatDate(
      getNewDate(leg.arrdate),
      DATE_MONTH_YEAR_VIEW_FORMAT,
    )} ${formatTimeString(leg.arrtime)}\n`;
    message += 'Cabin Baggage: 7Kg\n';
    message += `Checkin Baggage: ${getCabinBaggage(
      baggageWeights[index],
      baggageUnits[index],
    )}\n`;

    if (index < legs.length - 1) {
      message += `-------- ${getConnectingTime(
        leg.arrtime,
        leg.arrdate,
        legs[index + 1].deptime,
        legs[index + 1].depdate,
      )} layover in ${leg.destination_name} -------\n\n`;
    }
  });

  message += `\nCabin Type : ${cabinType}\n`;
  message += `Stops : ${getStopsText(flight?.numstops ?? legs.length - 1)}\n`;
  if (showFare) {
    message += `${
      fare?.faretype || 'Flight'
    } Fare : ${currency} ${fareAmount}\n`;
  }
  message += `No. of passenger: ${passengerCount}\n`;
  message += `Duration: ${convertTravelTime(
    flight?.totaljourneyduration || 0,
  )}\n`;

  return message;
};
